import { nanoid } from 'nanoid';
import React, { useState, createContext } from 'react';
import { BoldSubtitle } from 'components/Text';
import useStyles from './FormStyles';
export const FormElementIdContext = /*#__PURE__*/createContext('');
export default function FormElement({
  title,
  children,
  childId: id
}) {
  const {
    spacingBottom
  } = useStyles();
  const [childId] = useState(id ?? nanoid());
  return /*#__PURE__*/React.createElement("div", {
    className: spacingBottom
  }, /*#__PURE__*/React.createElement(BoldSubtitle, {
    component: "label",
    htmlFor: childId
  }, title), /*#__PURE__*/React.createElement(FormElementIdContext.Provider, {
    value: childId
  }, children));
}
FormElement.defaultProps = {
  childId: undefined
};